<template>
  <div
    class="flex-column"
    style="padding-top: 10px;"
  >
    <div v-show="readonly" style="display: flex;">
      <el-button type="primary" @click="isEdit=true">{{ $t('SystemMaintenance.Edit') }}</el-button>
      <el-button type="primary" @click="onLobChange">{{ $t('SystemMaintenance.Refresh') }}</el-button>
      <el-button type="primary" @click="lookConfig">{{ $t('CargoMsg.Cargo_View') + this.tabNumberTitle + $t('CargoMsg.Cargo_Config') }}</el-button>
    </div>
    <div v-show="isEdit" style="display: flex;">
      <el-button type="primary" @click="save">{{ $t('SystemMaintenance.Save') }}</el-button>
      <el-button type="primary" @click="onLobChange">{{ $t('SystemMaintenance.Refresh') }}</el-button>
      <el-button type="primary" @click="reset">{{ $t('SystemMaintenance.Reset') }}</el-button>
      <el-button type="primary" @click="isEdit=false">{{ $t('SystemMaintenance.Cancel') }}</el-button>
      <el-button v-if="isMbl" type="primary" @click="serviceCode.visible=true">{{ $t('SystemMaintenance.ServiceCodeMaintenance') }}</el-button>
    </div>
    <el-form label-width="90px" label-position="left" :inline="true" style="margin-top: 10px">
      <el-form-item v-if="showLob||showHblLob||showBill" :label="$t('SystemMaintenance.BusinessType')">
        <el-select v-model="lob" @change="onLobChange">
          <el-option
            v-for="(item,index) in lobSource"
            :key="index"
            :label="item.name"
            :value="item.value"
          />
        </el-select>
      </el-form-item>
      <el-form-item v-if="showBill" :label="$t('SystemMaintenance.BillOfLadingType')">
        <el-select v-model="billType" @change="onLobChange">
          <el-option
            v-for="(item,index) in billTypeSource"
            :key="index"
            :label="item.name"
            :value="item.value"
          />
        </el-select>
      </el-form-item>
    </el-form>
    <el-form label-width="90px" label-position="left" style="width:700px">
      <el-form-item v-if="isMbl" :label="$t('SystemMaintenance.RuleName')">
        <el-select v-model="ruleName" style="width: 500px" @change="ruleChange">
          <el-option v-for="(item,index) in rules" :key="index" :value="item" />
        </el-select>
        <span v-if="!readonly">
          <i class="el-icon-circle-plus" style="font-size: 18px;cursor: pointer;margin-left: 5px;color: #1F75D5" @click="addRule.visible = true" />
          <i v-if="rules.length && details.name" class="el-icon-delete" style="font-size: 18px;cursor: pointer;margin-left: 5px;color: #ff0000" @click="removeRule" />
        </span>
      </el-form-item>
      <el-form-item v-if="isMbl" :label="$t('SystemMaintenance.DesignatedShippingLine')">
        <cargo-advance-select
          :select-type="selectTypeNames.basic_data_Company"
          :method-params="{seaCmp:true,active:true}"
          :default-value="details.partnerId"
          :disabled="readonly"
          filterable
          style="width: 500px"
          @parentCallBack="partnerIdChange"
        />
      </el-form-item>
      <el-form-item :label="$t('SystemMaintenance.Expression')">
        <el-input v-model="config.value" :disabled="true" style="width: 500px" />
      </el-form-item>
      <el-form-item :label="$t('SystemMaintenance.Example')">
        <div>
          <el-input v-model="example" :disabled="true" style="width: 500px" />
          <span style="color:red">长度:{{ example.length }}</span>
        </div>
      </el-form-item>
      <el-form-item label-width="0">
        <span>请选择{{ tabTitle }}的组成元素</span>
      </el-form-item>
    </el-form>
    <el-row :gutter="10" type="flex" style="margin: 0">
      <el-col :span="8">
        <el-form :disabled="readonly || tabName === 'WriteOffNo'">
          <el-form-item>
            <el-checkbox
              v-if="showLob||showHblLob"
              v-model="form.lob"
              @change="toPattern('lob')"
            >{{ $t('SystemMaintenance.BusinessTypelob') }}</el-checkbox>
            <el-input
              v-show="lob === 'RI' || lob === 'RE'"
              id="lob-val1"
              v-model="form.val1"
              :disabled="!form.lob"
              style="float:right;width:60px;"
              @change="toPattern('lob')"
            />
          </el-form-item>
          <el-form-item v-if="showLob&&(lob==='SE'||lob==='SI'||lob==='RE'||lob==='RI'||lob==='IE')&&!isMbl">
            <el-checkbox
              v-model="form.containerLoadType.checked"
              @change="toPattern('containerLoadType')"
            >{{ lob === 'IE'? $t('SeaExport.ComprehensiveLogisticsOrderType'):$t('SeaExport.FLCLType') }}</el-checkbox>
            <el-input
              id="containerLoadType-val2"
              v-model="form.containerLoadType.val2"
              :disabled="!form.containerLoadType.checked"
              style="float:right;width:60px"
              @change="toPattern('containerLoadType')"
            />
            <el-input
              id="containerLoadType-val1"
              v-model="form.containerLoadType.val1"
              :disabled="!form.containerLoadType.checked"
              style="float:right;width:60px;margin-right:10px"
              @change="toPattern('containerLoadType')"
            />
          </el-form-item>
          <el-form-item v-if="showLob && (lob==='IE')&&!isMbl">
            <el-checkbox
              v-model="form.operateType.checked"
              @change="toPattern('operateType')"
            >{{ $t('SeaExport.OperateType') }}</el-checkbox>
            <el-input
              id="operateType-val2"
              v-model="form.operateType.val2"
              :disabled="!form.operateType.checked"
              style="float:right;width:60px"
              @change="toPattern('operateType')"
            />
            <el-input
              id="operateType-val1"
              v-model="form.operateType.val1"
              :disabled="!form.operateType.checked"
              style="float:right;width:60px;margin-right:10px"
              @change="toPattern('operateType')"
            />
          </el-form-item>
          <el-form-item v-if="showLob&&!isMbl">
            <el-checkbox v-model="form.cargoSource.checked" @change="toPattern('cargoSource')">{{ $t('SystemMaintenance.CargoPickupType') }}</el-checkbox>
            <el-input
              id="cargoSource-val2"
              v-model="form.cargoSource.val2"
              :disabled="!form.cargoSource.checked"
              style="float:right;width:60px"
              @change="toPattern('cargoSource')"
            />
            <el-input
              id="cargoSource-val1"
              v-model="form.cargoSource.val1"
              :disabled="!form.cargoSource.checked"
              style="float:right;width:60px;margin-right:10px"
              @change="toPattern('cargoSource')"
            />
          </el-form-item>
          <el-form-item v-if="showOffice">
            <el-checkbox v-model="form.office" @change="toPattern('office')">{{ $t('SystemMaintenance.BranchCodeoffice') }}</el-checkbox>
          </el-form-item>
          <el-form-item v-if="showPartnerWarehouseCode">
            <el-checkbox v-model="form.partnerWarehouseCode.checked" @change="partnerWarehouseCodeChangeHandle()">{{ $t('SystemMaintenance.PartnerWarehouseCode') }}</el-checkbox>
            <el-tooltip :content="$t('SystemMaintenance.PartnerWarehouseCodeTip')">
              <i class="el-icon-warning" style="color: #e6a23c;margin-left: 5px" />
            </el-tooltip>
            <el-button type="primary" style="float:right;" :disabled="!form.partnerWarehouseCode.checked" @click="warehouseCodePriorityDialog.visible = true">{{ $t('CargoMsg.Cargo_ValueSetting') }}</el-button>
          </el-form-item>
          <el-form-item v-if="showUserCode">
            <el-checkbox v-model="form.userCode" @change="toPattern('userCode')">{{ $t('SystemMaintenance.Salesperson') }}</el-checkbox>
          </el-form-item>
          <el-form-item v-if="showOp">
            <el-checkbox v-model="form.opCode" @change="toPattern('opCode')">{{ $t('SystemMaintenance.Operation') }}</el-checkbox>
          </el-form-item>
          <el-form-item v-if="showNetCode">
            <el-checkbox v-model="form.netCode" @change="toPattern('netCode')">{{ $t('SystemMaintenance.NetCodenetCode') }}</el-checkbox>
          </el-form-item>
          <el-form-item v-if="showDepart">
            <el-checkbox v-model="form.salesDepart" @change="toPattern('salesDepart')">{{ $t('SystemMaintenance.SalesDepartment') }}</el-checkbox>
          </el-form-item>
          <el-form-item v-if="showDepart">
            <el-checkbox v-model="form.opDepart" @change="toPattern('opDepart')">{{ $t('SystemMaintenance.OperationsDepartment') }}</el-checkbox>
          </el-form-item>
          <el-form-item v-if="showWarehouseCode && lob.startsWith('FBA')">
            <el-checkbox v-model="form.warehouseCode" @change="toPattern('warehouseCode')">{{ $t('SystemMaintenance.OverseasWarehouseCodeFBAFC') }}</el-checkbox>
          </el-form-item>
          <el-form-item v-if="showPort && !isWarehouse">
            <el-checkbox v-model="form.basicPol" @change="toPattern('basicPol')">{{ $t('SystemMaintenance.PolCode') }}</el-checkbox>
          </el-form-item>
          <el-form-item v-if="showPort">
            <el-checkbox v-model="form.port" @change="toPattern('port')">{{ isWarehouse ? $t('SystemMaintenance.PortCodeport') : $t('SystemMaintenance.DeliveryPlaceCodeport') }}</el-checkbox>
          </el-form-item>
          <el-form-item v-if="showHblLob">
            <el-checkbox v-model="form.pol" @change="toPattern('pol')">{{ $t('SystemMaintenance.DeparturePortCode') }}</el-checkbox>
          </el-form-item>
          <el-form-item v-if="showHblLob">
            <el-checkbox v-model="form.pod" @change="toPattern('pod')">{{ $t('SystemMaintenance.DestinationPortCode') }}</el-checkbox>
          </el-form-item>
          <el-form-item v-if="isMbl">
            <el-checkbox v-model="form.polExCode" @change="toPattern('polExCode')">{{ $t('SystemMaintenance.DeparturePortExchangeCode') }}</el-checkbox>
          </el-form-item>
          <el-form-item v-if="isMbl">
            <el-checkbox v-model="form.podExCode" @change="toPattern('podExCode')">{{ $t('SystemMaintenance.DestinationPortExchangeCode') }}</el-checkbox>
          </el-form-item>
          <el-form-item v-if="isMbl">
            <el-checkbox v-model="form.groupCode" @change="toPattern('groupCode')">{{ $t('SystemMaintenance.ServiceCode') }}</el-checkbox>
          </el-form-item>
          <el-form-item v-if="showHblLob">
            <el-checkbox v-model="form.sacaCode" @change="toPattern('sacaCode')">{{ $t('SystemMaintenance.OverseasAgentCode') }}</el-checkbox>
          </el-form-item>
          <el-form-item v-if="showJobNo">
            <el-checkbox v-model="form.jobNo" @change="toPattern('jobNo')">{{ $t('SystemMaintenance.JobNumberjobNo') }}</el-checkbox>
          </el-form-item>
          <el-form-item v-if="showRp">
            <el-checkbox v-model="form.rp" @change="toPattern('rp')">{{ $t('SystemMaintenance.ReceivableOrPayable') }}</el-checkbox>
          </el-form-item>
          <el-form-item v-if="showDate||showHblLob||showWarehouseNo">
            <el-checkbox
              v-model="form.year.checked"
              @change="toPattern('year')"
            >{{ showHblLob ? $t('SystemMaintenance.Jobyear') : $t('SystemMaintenance.Yearyear') }}</el-checkbox>
            <el-input-number
              v-model="form.year.length"
              :disabled="!form.year.checked"
              controls-position="right"
              :min="1"
              :max="4"
              :precision="0"
              style="float:right;width:85px"
              @change="toPattern('year')"
            />
            <span style="float:right;margin-right:10px">{{ $t('SystemMaintenance.Length') }}</span>
          </el-form-item>
          <el-form-item v-if="showDate||showHblLob||showWarehouseNo">
            <el-checkbox
              v-model="form.month.checked"
              @change="toPattern('month')"
            >{{ showHblLob ? $t('SystemMaintenance.Jobmonth') : $t('SystemMaintenance.Monthmonth') }}</el-checkbox>
            <el-input-number
              v-model="form.month.length"
              :disabled="!form.month.checked"
              controls-position="right"
              :min="1"
              :max="2"
              :precision="0"
              style="float:right;width:85px"
              @change="toPattern('month')"
            />
            <span style="float:right;margin-right:10px">{{ $t('SystemMaintenance.Length') }}</span>
          </el-form-item>
          <el-form-item v-if="showDate||showWarehouseNo">
            <el-checkbox v-model="form.day.checked" @change="toPattern('day')">{{ $t('SystemMaintenance.Dateday') }}</el-checkbox>
            <el-input-number
              v-model="form.day.length"
              :disabled="!form.day.checked"
              controls-position="right"
              :min="1"
              :max="2"
              :precision="0"
              style="float:right;width:85px"
              @change="toPattern('day')"
            />
            <span style="float:right;margin-right:10px">{{ $t('SystemMaintenance.Length') }}</span>
          </el-form-item>
          <template v-if="tabName === 'JobNo' || tabName === 'MblNo' || tabName === 'HblNo'">
            <el-form-item v-if="lob === 'SE' || lob === 'AE'">
              <el-checkbox v-model="form.etd" @change="toPattern('etd')">{{ $t('SystemMaintenance.DepartureDate') }}</el-checkbox>
              <el-tooltip :content="$t('SystemMaintenance.YearMonthEtdTip')" placement="right">
                <i class="el-icon-warning" style="padding: 0 5px;color: #E6A23C;font-size: 14px;" />
              </el-tooltip>
            </el-form-item>
            <el-form-item v-if="lob === 'SI' || lob === 'AI'">
              <el-checkbox v-model="form.eta" @change="toPattern('eta')">{{ $t('SystemMaintenance.ArrivalDate') }}</el-checkbox>
              <el-tooltip :content="$t('SystemMaintenance.YearMonthEtaTip')" placement="right">
                <i class="el-icon-warning" style="padding: 0 5px;color: #E6A23C;font-size: 14px;" />
              </el-tooltip>
            </el-form-item>
            <el-form-item v-if="lob === 'RI'">
              <el-checkbox v-model="form.eta" @change="toPattern('eta')">{{ $t('RailwayExport.ETA') }}</el-checkbox>
              <el-tooltip :content="$t('SystemMaintenance.RiYearMonthEtaTip')" placement="right">
                <i class="el-icon-warning" style="padding: 0 5px;color: #E6A23C;font-size: 14px;" />
              </el-tooltip>
            </el-form-item>
          </template>
          <template v-if="(tabName === 'JobNo' && !['SE', 'AE', 'SI', 'AI', 'RI'].includes(lob) || tabName !== 'JobNo') && tabName !== 'MblNo' && tabName !== 'HblNo'">
            <el-form-item v-if="showLob&&(lob==='SE'||lob==='AE')">
              <el-checkbox v-model="form.etd" @change="toPattern('etd')">{{ $t('SystemMaintenance.DepartureDate') }}</el-checkbox>
            </el-form-item>
            <el-form-item v-if="lob==='RE' && ((showLob && showDepart) || showWarehouseNo)">
              <el-checkbox v-model="form.etd" @change="toPattern('etd')">{{ $t('SystemMaintenance.ShippingDate') }}</el-checkbox>
            </el-form-item>
            <el-form-item v-if="lob==='RI'">
              <el-checkbox v-if="showLob" v-model="form.etd" style="padding-right: 30px;" @change="toPattern('etd')">{{ $t('SystemMaintenance.ShippingDate') }}</el-checkbox>
            </el-form-item>
            <el-form-item v-if="showLob&&(lob==='SI'||lob==='AI')">
              <el-checkbox v-model="form.etd" style="padding-right: 30px;" @change="toPattern('etd')">{{ $t('SystemMaintenance.DepartureDate') }}</el-checkbox>
            </el-form-item>
          </template>
          <el-form-item v-if="showJobSequence">
            <el-checkbox
              v-model="form.jobSequence.checked"
              @change="toPattern('jobSequence')"
            >{{ $t('SystemMaintenance.JobSequenceNumberjobSequence') }}</el-checkbox>
            <el-input-number
              v-model="form.jobSequence.length"
              :disabled="!form.jobSequence.checked"
              controls-position="right"
              :min="1"
              :max="5"
              :precision="0"
              style="float:right;width:85px"
              @change="toPattern('jobSequence')"
            />
            <span style="float:right;margin-right:10px">{{ $t('SystemMaintenance.Length') }}</span>
          </el-form-item>
          <el-form-item v-if="showRandomLetters">
            <el-checkbox
              v-model="form.randomLetter.checked"
              @change="toPattern('randomLetter')"
            >{{ $t('SystemMaintenance.RandomLetters') }}</el-checkbox>
            <el-input-number
              v-model="form.randomLetter.length"
              :disabled="!form.randomLetter.checked"
              controls-position="right"
              :min="1"
              :max="4"
              :precision="0"
              style="float:right;width:85px"
              @change="toPattern('randomLetter')"
            />
            <span style="float:right;margin-right:10px">{{ $t('SystemMaintenance.Length') }}</span>
          </el-form-item>
          <el-form-item v-if="showSequence">
            <el-checkbox
              v-model="form.sequence.checked"
              @change="toPattern('sequence')"
            >{{ $t('SystemMaintenance.SequenceNumbersequence') }}</el-checkbox>
            <el-input-number
              v-model="form.sequence.length"
              :disabled="!form.sequence.checked"
              controls-position="right"
              :min="1"
              :max="9"
              :precision="0"
              style="float:right;width:85px"
              @change="toPattern('sequence')"
            />
            <span style="float:right;margin-right:10px">{{ $t('SystemMaintenance.Length') }}</span>
          </el-form-item>
          <el-form-item v-if="showCustomJobType">
            <el-checkbox
              v-model="form.customJobType.checked"
              @change="toPattern('customJobType')"
            >{{ $t('SystemMaintenance.CustomBusinessTypecustomJobType') }}</el-checkbox>
            <el-input-number
              v-model="form.customJobType.length"
              :disabled="!form.customJobType.checked"
              controls-position="right"
              :min="1"
              :max="4"
              :precision="0"
              style="float:right;width:85px"
              @change="toPattern('customJobType')"
            />
            <span style="float:right;margin-right:10px">{{ $t('SystemMaintenance.Length') }}</span>
          </el-form-item>
        </el-form>
        <el-card class="box-card">
          <div slot="header">
            <span>{{ $t('SystemMaintenance.SequenceNumberSettings') }}</span>
          </div>
          <el-form :disabled="readonly||!form.sequence.checked">
            <el-radio-group v-model="form.sequence.set" :disabled="tabName === 'WriteOffNo'" @change="toPattern('sequence')">
              <el-form-item style="height:30px">
                <el-radio label="N" style="float:left">{{ $t('SystemMaintenance.NeverResetN') }}</el-radio>
                <el-radio label="Y" style="float:left">{{ $t('SystemMaintenance.ResetByYearY') }}</el-radio>
              </el-form-item>
              <el-form-item style="height:30px">
                <el-radio label="M" style="float:left">{{ $t('SystemMaintenance.ResetByMonthM') }}</el-radio>
                <el-radio label="D" style="float:left">{{ $t('SystemMaintenance.ResetByDayD') }}</el-radio>
              </el-form-item>
            </el-radio-group>
            <el-form-item v-if="showLob&&lob==='IE'">
              <el-checkbox v-model="form.businessDate" @change="toPattern('businessDate')">{{ $t('SystemMaintenance.BusinessDate') }}</el-checkbox>
            </el-form-item>
            <template v-if="(tabName === 'JobNo' && !['SE', 'AE', 'SI', 'AI', 'RI'].includes(lob) || tabName !== 'JobNo') && tabName !== 'MblNo' && tabName !== 'HblNo'">
              <el-form-item v-if="lob==='RI' && ((showLob && showDepart) || showWarehouseNo)">
                <el-checkbox v-model="form.eta" @change="toPattern('eta')">{{ $t('RailwayExport.ETA') }}</el-checkbox>
              </el-form-item>
              <el-form-item v-if="showLob&&(lob==='SI'||lob==='AI')">
                <el-checkbox v-model="form.eta" @change="toPattern('eta')">{{ $t('SystemMaintenance.ArrivalDate') }}</el-checkbox>
              </el-form-item>
            </template>
            <el-form-item :disabled="tabName === 'WriteOffNo'">
              <el-checkbox v-model="form.sequence.O" :disabled="tabName === 'WriteOffNo'" @change="toPattern('sequence')">{{ $t('SystemMaintenance.BranchSequenceNumberIndependent') }}</el-checkbox>
            </el-form-item>
            <el-form-item v-if="showCustomJobType">
              <el-checkbox v-model="form.sequence.C" @change="toPattern('sequence')">{{ $t('SystemMaintenance.CustomJobTypeSequenceNumberIndependent') }}</el-checkbox>
            </el-form-item>
            <el-form-item v-if="showIo">
              <el-checkbox v-model="form.sequence.F" @change="p=>{changeIo(form.sequence.F);toPattern('sequence')}">{{ $t('SystemMaintenance.PaymentDirectionSerialNo') }}</el-checkbox>
            </el-form-item>
            <el-form-item v-if="showBillDate">
              <el-checkbox v-model="form.billDate" @change="toPattern('billDate')">{{ (this.tabName === 'BillingInternalNo' || this.tabName === 'BillingNo') ? $t('SystemMaintenance.TakeBillDateOnYearMonthDay') : $t('SystemMaintenance.TakeDocumentDateOnYearMonthDay') }}</el-checkbox>
              <el-tooltip>
                <i class="el-icon-warning" style="color:#f4973a; cursor: pointer;margin-left: 20px;margin-right: 2px" />{{ $t('SystemMaintenance.UseBillDateOnYearMonthDay') }}
              </el-tooltip>
            </el-form-item>
            <el-form-item v-if="showPayDate">
              <el-checkbox v-model="form.payDate" @change="toPattern('payDate')">{{ $t('SystemMaintenance.TakeActualPayDateOnYearMonthDay') }}</el-checkbox>
              <el-tooltip>
                <i class="el-icon-warning" style="color:#f4973a; cursor: pointer;margin-left: 20px;margin-right: 2px" />{{ $t('SystemMaintenance.UseActualPayDateOnYearMonthDay') }}
              </el-tooltip>
            </el-form-item>
          </el-form>
        </el-card>
        <el-checkbox
          v-if="showIo"
          v-model="form.io"
          :disabled="readonly || form.sequence.F"
          @change="toPattern('io')"
        >{{ $t('SystemMaintenance.ReceivableAndPayableio') }}</el-checkbox>
      </el-col>
      <el-col :span="8" style="display:flex;flex-direction: column">
        <el-checkbox v-model="config.overrideable" :disabled="readonly||tabName === 'WriteOffNo'">{{ $t('SystemMaintenance.BranchConfigurationIndependent') }}</el-checkbox>
        <div style="display: flex;flex-grow: 1">
          <div style="display: flex;flex-grow: 1;flex-direction: column">
            <el-table
              ref="table"
              :class="readonly?'not-click':''"
              :data="expressList"
              :show-header="false"
              border
              highlight-current-row
              style="flex-grow:1"
              @current-change="handleCurrentChange"
            >
              <el-table-column>
                <template slot-scope="{row}">
                  <div :class="row.isConstant?'row-constant':''" style="padding:0 3px 0 5px">
                    <span v-if="showHblLob">{{ row.name|filterName }}</span>
                    <span v-else>{{ row.name }}</span>
                    <span v-if="row.isConstant" style="float:right">
                      <i class="el-icon-edit edit-btn" @click="showConstantDialog(row)" />
                      <i class="el-icon-delete delete-btn" @click="deleteConstant(row.sequence)" />
                    </span>
                  </div>
                </template>
              </el-table-column>
            </el-table>
            <el-card v-if="isMbl" class="box-card" style="margin-top: 5px">
              <div slot="header">
                <span>{{ $t('SystemMaintenance.JoiningDeclarationNumberRule') }}</span>
              </div>
              <el-form inline :disabled="readonly">
                <el-form-item>
                  <el-checkbox v-model="details.childNoLetter" :label="$t('SystemMaintenance.LetterSuffix')" />
                </el-form-item>
                <el-form-item>
                  <el-checkbox v-model="details.childNoLetterFriendly" :label="$t('SystemMaintenance.LetterexcludingIAndO')" />
                </el-form-item>
                <el-form-item>
                  <el-checkbox v-model="details.childNoNumber" :label="$t('SystemMaintenance.NumberSuffix')" />
                </el-form-item>
                <el-form-item>
                  <el-checkbox v-model="details.childNoExtension" :label="$t('SystemMaintenance.MasterBillExtension')" />
                </el-form-item>
                <el-form-item :label="$t('SystemMaintenance.SuffixSeparator')">
                  <el-select v-model="details.childNoSplit">
                    <el-option :label="$t('SystemMaintenance.None')" value="" />
                    <el-option label="-" value="-" />
                    <el-option label="*" value="*" />
                  </el-select>
                </el-form-item>
              </el-form>
            </el-card>
          </div>
          <div class="flex-column">
            <el-button type="primary" :disabled="readonly||tabName === 'WriteOffNo'" style="margin-left: 5px;margin-bottom: 5px;" @click="showConstantDialog()">{{ $t('SystemMaintenance.AddConstant') }}</el-button>
            <el-button :disabled="readonly||!currentExpress||tabName === 'WriteOffNo'" type="primary" style="margin-left: 5px;margin-bottom: 5px" @click="moveUp">↑</el-button>
            <el-button :disabled="readonly||!currentExpress||tabName === 'WriteOffNo'" type="primary" @click="moveDown">↓</el-button>
          </div>
        </div>
      </el-col>
    </el-row>
    <div class="inner-row" style="color:red">{{ remark }}</div>
    <!-- 常量对话框 -->
    <el-dialog
      v-el-drag-dialog
      :visible.sync="constantDialog.visible"
      :title="constantDialog.title"
      width="300px"
      :close-on-click-modal="false"
    >
      <div class="inner-row">
        <el-form label-width="40px" label-position="left">
          <el-form-item :label="$t('SystemMaintenance.Constant')">
            <el-input v-model="constantDialog.express.text" />
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer">
        <el-button type="primary" @click="saveConstant()">{{ $t('common.btn.save') }}</el-button>
        <el-button @click="constantDialog.visible=false">{{ $t('common.btn.cancel') }}</el-button>
      </span>
    </el-dialog>
    <el-dialog
      v-if="isMbl"
      :title="$t('SystemMaintenance.AddRule')"
      :visible="addRule.visible"
      width="400px"
    >
      <el-form label-position="top">
        <el-form-item :label="$t('SystemMaintenance.PleaseEnterRuleName')">
          <el-input v-model="addRule.name" />
        </el-form-item>
      </el-form>
      <span slot="footer">
        <el-button type="primary" @click="handleAddRule">{{ $t('common.btn.save') }}</el-button>
        <el-button @click="addRule.visible=false">{{ $t('common.btn.cancel') }}</el-button>
      </span>
    </el-dialog>
    <service-code-dialog
      v-if="isMbl"
      :visible="serviceCode.visible"
      @close="serviceCode.visible = false"
    />
    <warehouse-code-priority-dialog
      :visible.sync="warehouseCodePriorityDialog.visible"
      :val-list="form.partnerWarehouseCode.valList"
      @confirm="warehouseCodePriorityConfirmHandle($event)"
    />
    <!--单号配置弹窗-->
    <number-config-search-dialog
      v-if="lookConfigDialog.visible"
      ref="numberConfigSearchDialog"
      :tab-name="tabName"
      :tab-number-title="tabNumberTitle"
      :visible.sync="lookConfigDialog.visible"
      @query="queryHandle"
    />
  </div>
</template>

<script>
import { cacheName, cache } from '@/utils/cacheManager'
import { AutoIncrementNum, deepCopy } from '@/utils/commonUtil'
import { getOfficeConfigByName, saveOfficeConfig, validConfig, deleteConfig, queryAllConfig } from '@/api/user'
import CargoAdvanceSelect from '@/components/Cargo/Common/cargoAdvanceSelect'
import { TYPE_NAMES } from '@/utils/class/AdvanceSelect'
import ServiceCodeDialog from '@/views/cargo/v0/SystemMaintenance/components/ServiceCodeDialog'
import { getLoading } from '@/utils/utilBaseElement'
import WarehouseCodePriorityDialog from '@/views/cargo/v0/SystemMaintenance/components/warehouseCodePriorityDialog'
import { WarehouseCodeUtil } from '@/class/cargo/model/utils/WarehouseCodeUtil'
import NumberConfigSearchDialog from '@/views/cargo/v0/SystemMaintenance/components/NumberConfigSearchDialog.vue'

export default {
  name: 'NoConfigList',
  components: { NumberConfigSearchDialog, ServiceCodeDialog, CargoAdvanceSelect, WarehouseCodePriorityDialog },
  filters: {
    filterName: function(val) {
      switch (val) {
        case 'year':
          return 'jobYear'
        case 'month':
          return 'jobMonth'
        default:
          return val
      }
    }
  },
  props: {
    defaultPattern: {
      type: String,
      default: ''
    },
    tabTitle: {
      type: String,
      default: ''
    },
    tabNumberTitle: {
      type: String,
      default: ''
    },
    tabName: {
      type: String,
      default: ''
    },
    selectLob: {
      type: String,
      default: ''
    },
    maxLength: {
      type: Number,
      default: 16
    },
    isMbl: {
      type: Boolean,
      default: false
    },
    showLob: {
      type: Boolean,
      default: true
    },
    showHblLob: {
      type: Boolean,
      default: false
    },
    showUserCode: {
      type: Boolean,
      default: true
    },
    showNetCode: {
      type: Boolean,
      default: false
    },
    showPort: {
      type: Boolean,
      default: true
    },
    showOffice: {
      type: Boolean,
      default: true
    },
    showJobNo: {
      type: Boolean,
      default: false
    },
    showDate: {
      type: Boolean,
      default: true
    },
    showJobSequence: {
      type: Boolean,
      default: false
    },
    showSequence: {
      type: Boolean,
      default: true
    },
    showDepart: {
      type: Boolean,
      default: false
    },
    showWarehouseCode: {
      type: Boolean,
      default: false
    },
    showOp: {
      type: Boolean,
      default: true
    },
    showIo: {
      type: Boolean,
      default: false
    },
    showRp: {
      type: Boolean,
      default: false
    },
    showBillDate: {
      type: Boolean,
      default: false
    },
    showPayDate: {
      type: Boolean,
      default: false
    },
    remark: {
      type: String,
      default: ''
    },
    showBill: {
      type: Boolean,
      default: false
    },
    selectBillType: {
      type: String,
      default: ''
    },
    showWarehouseNo: {
      type: Boolean,
      default: false
    },
    showCustomJobType: {
      type: Boolean,
      default: false
    },
    // 合作伙伴进仓编号代码
    showPartnerWarehouseCode: {
      type: Boolean,
      default: false
    },
    showRandomLetters: {
      type: Boolean,
      default: false
    },
    isWarehouse: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      selectTypeNames: TYPE_NAMES,
      loading: null,
      isEdit: false,
      lobSource: [],
      lob: '',
      billTypeSource: [],
      billType: '',
      config: {
        value: '',
        overrideable: false
      },
      lookConfigDialog: {
        name: '',
        visible: false
      },
      ruleName: '',
      details: {
        name: '',
        partnerId: '',
        childNoExtension: false,
        childNoLetter: true,
        childNoLetterFriendly: false,
        childNoNumber: false,
        childNoSplit: ''
      },
      rules: [],
      example: '',
      initialForm: {},
      form: {
        lob: false,
        val1: 'RE',
        containerLoadType: { checked: false, val1: 'F', val2: 'E' },
        operateType: { checked: false, val1: 'Z', val2: 'F' },
        cargoSource: { checked: false, val1: 'N', val2: 'F' },
        office: false,
        userCode: false,
        netCode: false,
        salesDepart: false,
        opCode: false,
        opDepart: false,
        warehouseCode: false,
        basicPol: false,
        port: false,
        pol: false,
        pod: false,
        polExCode: false,
        podExCode: false,
        groupCode: false,
        sacaCode: false,
        jobNo: false,
        year: { checked: false, length: 2 },
        month: { checked: false, length: 2 },
        day: { checked: false, length: 2 },
        jobSequence: { checked: false, length: 4 },
        randomLetter: { checked: false, length: 2 },
        sequence: { checked: false, length: 4, set: 'N', O: true, C: false, F: false },
        customJobType: { checked: false, length: 4 },
        etd: false,
        atd: false,
        eta: false,
        io: false,
        businessDate: false, // 业务日期
        partnerWarehouseCode: { checked: false, valList: [] },
        rp: false,
        billDate: false,
        payDate: false
      },
      expressList: [],
      currentExpress: null,
      autoIncrementNum: new AutoIncrementNum(),
      constantDialog: {
        visible: false,
        title: '',
        express: {}
      },
      addRule: {
        name: '',
        visible: false
      },
      serviceCode: {
        visible: false
      },
      warehouseCodePriorityDialog: {
        visible: false
      }
    }
  },
  computed: {
    readonly() {
      return !this.isEdit
    },
    containerLoadTypeVal1() {
      return this.form.containerLoadType.val1
    },
    containerLoadTypeVal2() {
      return this.form.containerLoadType.val2
    },
    operateTypeVal1() {
      return this.form.operateType.val1
    },
    operateTypeVal2() {
      return this.form.operateType.val2
    },
    cargoSourceVal1() {
      return this.form.cargoSource.val1
    },
    cargoSourceVal2() {
      return this.form.cargoSource.val2
    },
    currentOffice() {
      return this.$store.getters.currentOfficeId
    }
  },
  watch: {
    containerLoadTypeVal1(newVal, oldVal) {
      if (document.activeElement.id === 'containerLoadType-val1') {
        if (!newVal) {
          this.form.containerLoadType.val1 = oldVal
        }
      }
    },
    containerLoadTypeVal2(newVal, oldVal) {
      if (document.activeElement.id === 'containerLoadType-val2') {
        if (!newVal) {
          this.form.containerLoadType.val2 = oldVal
        }
      }
    },
    operateTypeVal1(newVal, oldVal) {
      if (document.activeElement.id === 'operateType-val1') {
        if (!newVal) {
          this.form.operateType.val1 = oldVal
        }
      }
    },
    operateTypeVal2(newVal, oldVal) {
      if (document.activeElement.id === 'operateType-val2') {
        if (!newVal) {
          this.form.operateType.val2 = oldVal
        }
      }
    },
    cargoSourceVal1(newVal, oldVal) {
      if (document.activeElement.id === 'cargoSource-val1') {
        if (!newVal) {
          this.form.cargoSource.val1 = oldVal
        }
      }
    },
    cargoSourceVal2(newVal, oldVal) {
      if (document.activeElement.id === 'cargoSource-val2') {
        if (!newVal) {
          this.form.cargoSource.val2 = oldVal
        }
      }
    },
    currentOffice() {
      this.onLobChange(true)
    }
  },
  created() {
    this.initialForm = this.form
    if (this.showLob || this.showHblLob) {
      const lobSource = this.$constantI18n('allLobSource')
      const billTypeSource = this.$constantI18n('billTypeSource')
      let keys = []
      if (this.$checkPermission(['write_SENoSetting'])) {
        keys.push('SE')
      }
      if (this.$checkPermission(['write_SINoSetting'])) {
        keys.push('SI')
      }
      if (this.$checkPermission(['write_AENoSetting']) && !this.showBill) {
        keys.push('AE')
      }
      if (this.$checkPermission(['write_AINoSetting']) && !this.showHblLob && !this.showBill) {
        keys.push('AI')
      }
      if (this.$checkPermission(['write_RENoSetting']) && !this.showHblLob && !this.showBill) {
        keys.push('RE')
        keys.push('RI')
      }
      if (this.$checkPermission(['write_IENoSetting']) && !this.showHblLob && !this.showBill) {
        keys.push('IE')
      }
      if (this.showBill) {
        keys.push('SE', 'SI')
      } else if (!this.showHblLob) {
        keys.push('SE', 'SI', 'AE', 'AI', 'RE', 'RI')
      } else {
        keys.push('SE', 'SI', 'AE')
      }

      // 工作单号、进仓编号、FBA委托编号
      if (this.tabName === 'JobNo' || this.tabName === 'WareHouseNo' || this.tabName === 'TrustNo') {
        if (this.tabName === 'TrustNo') keys = []
        keys.push('FBASE')
        keys.push('FBAAE')
        keys.push('FBARE')
      }
      for (const item of lobSource) {
        if (keys.includes(item.value)) {
          this.lobSource.push(item)
        }
      }
      this.billTypeSource = billTypeSource
      if (this.lobSource.length > 0) {
        this.lob = this.selectLob ? this.selectLob : this.lobSource[0].value
      }
      if (this.billTypeSource.length > 0) {
        this.billType = this.selectBillType ? this.selectBillType : this.billTypeSource[0].value
      }
    }
    setTimeout(() => {
      this.onLobChange()
    })
  },
  methods: {
    partnerIdChange(e) {
      this.details.partnerId = e.value
    },
    async onLobChange(discardName = false) {
      this.loading = getLoading()
      try {
        await cache.load(cacheName.OFFICE, cacheName.DEPARTMENT)
        const res = await getOfficeConfigByName({
          officeId: cache.office.officeId,
          configName: this.lob + (this.tabName === 'BillNo' ? this.billType : '') + this.tabName + 'Pattern'
        })
        this.config = { ...res.data }
        if (this.config.details && this.isMbl) {
          const ruleName = discardName ? '' : this.ruleName
          this.rules = this.config.details.map(item => item.name)
          const details = {
            name: '',
            partnerId: '',
            childNoExtension: false,
            childNoLetter: true,
            childNoLetterFriendly: false,
            childNoNumber: false,
            childNoSplit: ''
          }
          if (ruleName) {
            this.details = this.config.details.find(item => item.name === ruleName) || details
          } else {
            this.details = this.config.details[0] || details
          }
          this.ruleName = this.details.name
          this.config.value = this.details.value
          this.config.overrideable = this.details.overrideable
        }
        this.toForm()
      } finally {
        this.loading.close()
      }
    },
    reset() {
      this.config.value = this.defaultPattern
      this.toForm()
    },
    toForm() {
      const form = deepCopy(this.initialForm)
      // 单独处理铁进初始化
      if (this.lob === 'RI') {
        form.val1 = 'RI'
      }
      const expressList = []
      /* 解析表达式 */
      const pattern = this.config.value
      let index = -1
      for (let i = 0; i < pattern.length; ++i) {
        if (pattern[i] === '$' && pattern[i + 1] === '{') {
          index = i
          continue
        }
        if (pattern[i] === '}' && index > -1) {
          let name = pattern.substring(index + 2, i)
          let value = null
          if (name.indexOf('containerLoadType') === 0 || name.indexOf('operateType') === 0 || name.indexOf('cargoSource') === 0) {
            const words = name.split(':')
            const subWords = words[1].split('|')
            name = words[0]
            value = { checked: true, val1: subWords[0] || '', val2: subWords[1] || '' }
          } else if ((this.lob === 'RE' || this.lob === 'RI') && name.indexOf('lob') === 0) {
            const words = name.split(':')
            if (words.length === 1) {
              name = 'lob'
              value = this.lob
            } else {
              name = words[0]
              value = words[1]
            }
            form.val1 = value
          } else if (name.indexOf('Y') === 0) {
            value = { checked: true, length: this.toCountChar(name, 'Y') }
            name = 'year'
          } else if (name.indexOf('M') === 0) {
            value = { checked: true, length: this.toCountChar(name, 'M') }
            name = 'month'
          } else if (name.indexOf('D') === 0) {
            value = { checked: true, length: this.toCountChar(name, 'D') }
            name = 'day'
          } else if (name.indexOf('J') === 0) {
            value = { checked: true, length: this.toCountChar(name, 'J') }
            name = 'jobSequence'
          } else if (name.indexOf('S') === 0) {
            const words = name.split(':')
            value = { checked: true, length: this.toCountChar(words[0], 'S'), set: '', O: false, C: false, F: false }
            const str = words[1] || ''
            for (let i = 0; i < str.length; ++i) {
              const c = str.charAt(i)
              if (c === 'O') {
                value.O = true
              } else if (c === 'C') {
                value.C = true
              } else if (c === 'F') {
                value.F = true
              } else {
                value.set = c
              }
            }
            name = 'sequence'
          } else if (name.indexOf('customJobType') === 0) {
            const words = name.split(':')
            value = { checked: true, length: words[1].length }
            name = words[0]
          } else if (name.indexOf('partnerWarehouseCode') === 0) {
            const words = name.split(':')
            const subWords = words[1].split('|')
            name = words[0]
            value = { checked: true, valList: subWords.map(subWord => ({ code: subWord, name: WarehouseCodeUtil.getName(subWord) })) }
          } else if (name.indexOf('rp') === 0) {
            value = true
            name = 'rp'
          } else if (name.indexOf('R') === 0) {
            value = { checked: true, length: this.toCountChar(name, 'R') }
            name = 'randomLetter'
          } else {
            name = name
            value = true
          }
          expressList.push({ name, text: pattern.substring(index, i + 1), value })
          index = -1
        }
      }
      /* 识别常量 */
      const expList = []
      let preIndex = 0
      let curIndex = 0
      for (const item of expressList) {
        curIndex = pattern.indexOf(item.text)
        if (curIndex > preIndex) {
          const name = pattern.substring(preIndex, curIndex)
          const text = name
          const sequence = this.autoIncrementNum.getNextNum()
          expList.push({ name, text, isConstant: true, sequence })
        }
        expList.push(item)
        preIndex = curIndex + item.text.length
      }
      if (preIndex < pattern.length) {
        const name = pattern.substring(preIndex)
        const text = name
        const sequence = this.autoIncrementNum.getNextNum()
        expList.push({ name, text, isConstant: true, sequence })
      }
      /* 表达式关联表单数据 */
      for (const item of expressList) {
        if ((this.lob === 'RI' || this.lob === 'RE') && item.name === 'lob') {
          form.lob = true
        } else {
          form[item.name] = item.value
        }
      }
      this.form = form
      this.expressList = expList
      this.toExample()
    },
    toCountChar(str, char) {
      let count = 0
      for (let i = 0; i < str.length; ++i) {
        if (str[i] === char) {
          count += 1
        }
      }
      return count
    },
    partnerWarehouseCodeChangeHandle() {
      // 初始化 合作伙伴进仓编码代码 取值列表 [客户、目的港代理、指定货代理]
      if (this.form['partnerWarehouseCode'].checked) {
        this.form['partnerWarehouseCode'].valList = [{ name: this.$t('CargoMsg.Cargo_Customer'), code: 'K' }, { name: this.$t('SeaExport.DestinationAgent'), code: 'M' }, { name: this.$t('CargoMsg.Cargo_NominatedAgent'), code: 'Z' }]
      } else {
        this.form['partnerWarehouseCode'].valList = []
      }
      this.toPattern('partnerWarehouseCode')
    },
    warehouseCodePriorityConfirmHandle(valList) {
      this.form['partnerWarehouseCode'].valList = valList
      this.toPattern('partnerWarehouseCode')
    },
    toPattern(name, key = null) {
      const formKey = key || name
      const value = this.form[formKey]
      /* 移除表达式 */
      if ((value instanceof Object && !value.checked) || !value) {
        this.form[formKey] = deepCopy(this.initialForm[formKey]) // 取消勾选后，重新初始化
        if (formKey === 'lob' && this.lob === 'RI') {
          this.form.val1 = 'RI'
        }
        this.expressList = this.expressList.filter(p => p.isConstant || p.name !== name)
        this.toMergeExpress()
        return
      }
      /* 编辑表达式 */
      const expressArr = this.expressList.filter(p => p.name === name)
      let express = null
      if (expressArr.length > 0) {
        express = expressArr[0]
      } else {
        express = { name, value }
        this.expressList.push(express)
      }
      switch (name) {
        case 'containerLoadType':
        case 'operateType':
        case 'cargoSource':
          express.text = '${' + name + ':' + value.val1 + '|' + value.val2 + '}'
          break
        case 'lob':
          if (this.lob === 'RE' || this.lob === 'RI') {
            express.text = '${' + name + ':' + this.form.val1 + '}'
          } else {
            express.text = '${' + name + '}'
          }
          break
        case 'year':
          express.text = '${' + this.toRepeatChar('Y', value.length) + '}'
          break
        case 'month':
          express.text = '${' + this.toRepeatChar('M', value.length) + '}'
          break
        case 'day':
          express.text = '${' + this.toRepeatChar('D', value.length) + '}'
          break
        case 'jobSequence':
          express.text = '${' + this.toRepeatChar('J', value.length) + '}'
          break
        case 'sequence':
          express.text = '${' + this.toRepeatChar('S', value.length) + ':'
          if (value.O) {
            express.text += 'O'
          }
          if (value.C) {
            express.text += 'C'
          }
          if (value.F) {
            express.text += 'F'
          }
          express.text += value.set + '}'
          break
        case 'customJobType':
          express.text = '${' + name + ':' + this.toRepeatChar('C', value.length) + '}'
          break
        case 'partnerWarehouseCode':
          express.text = '${' + name + ':' + value.valList.map(val => val.code).join('|') + '}'
          break
        case 'randomLetter':
          express.text = '${' + this.toRepeatChar('R', value.length) + '}'
          break
        default:
          express.text = '${' + name + '}'
          break
      }
      this.toMergeExpress()
    },
    toMergeExpress() {
      let pattern = ''
      for (const item of this.expressList) {
        pattern += item.text
      }
      this.config.value = pattern
      this.toExample()
    },
    toExample() {
      let example = ''
      for (const item of this.expressList) {
        if (item.isConstant) {
          example += item.text
          continue
        }
        example = this.doGetExample(item, example)
      }
      this.example = example
    },
    toFormatNumber(num, size) {
      let str = String(num)
      if (str.length > size) {
        str = str.substring(str.length - size)
      } else if (str.length < size) {
        str = this.toRepeatChar('0', size - str.length) + str
      }
      return str
    },
    toRepeatChar(char, num) {
      let result = ''
      for (let i = 0; i < num; ++i) {
        result += char
      }
      return result
    },
    handleCurrentChange(val) {
      this.currentExpress = val
    },
    showConstantDialog(row) {
      if (row) {
        this.constantDialog.express = deepCopy(row)
        this.constantDialog.title = this.$t('common.btn.edit')
      } else {
        this.constantDialog.express = {
          name: '',
          text: '',
          isConstant: true,
          sequence: ''
        }
        this.constantDialog.title = this.$t('common.btn.new')
      }
      this.constantDialog.visible = true
    },
    saveConstant() {
      const express = this.constantDialog.express
      const text = express.text
      if (!text) {
        this.$message.warning(this.$t('SystemMaintenance.ConstantCannotBeEmpty'))
        return
      }
      if (text.indexOf('$') > -1 || text.indexOf('{') > -1 || text.indexOf('}') > -1) {
        this.$message.warning(this.$t('SystemMaintenance.ConstantSpecialCharacters'))
        return
      }
      if (express.name) {
        this.currentExpress.name = text
        this.currentExpress.text = text
      } else {
        express.name = text
        express.sequence = this.autoIncrementNum.getNextNum()
        this.expressList.push(express)
      }
      this.toMergeExpress()
      this.constantDialog.visible = false
    },
    deleteConstant(sequence) {
      this.$confirm(this.$t('common.tips.confirmDelete'), this.$t('common.tips.prompt'), {
        confirmButtonText: this.$t('common.btn.ok'),
        cancelButtonText: this.$t('common.btn.cancel'),
        type: 'warning'
      }).then(() => {
        this.expressList = this.expressList.filter(p => !p.isConstant || p.sequence !== sequence)
        this.toMergeExpress()
      }).catch(() => { })
    },
    moveUp() {
      const expressList = this.expressList
      for (let i = 0; i < expressList.length; ++i) {
        const item = expressList[i]
        if (item.name === this.currentExpress.name) {
          if (item.isConstant !== this.currentExpress.isConstant) {
            continue
          }
          if (item.isConstant) {
            if (item.sequence !== this.currentExpress.sequence) {
              continue
            }
          }
          if (i > 0) {
            expressList[i] = expressList[i - 1]
            expressList[i - 1] = this.currentExpress
            this.expressList = [...expressList]
            this.toMergeExpress()
          }
          break
        }
      }
    },
    moveDown() {
      const expressList = this.expressList
      for (let i = 0; i < expressList.length; ++i) {
        const item = expressList[i]
        if (item.name === this.currentExpress.name) {
          if (item.isConstant !== this.currentExpress.isConstant) {
            continue
          }
          if (item.isConstant) {
            if (item.sequence !== this.currentExpress.sequence) {
              continue
            }
          }
          if (i < expressList.length - 1) {
            expressList[i] = expressList[i + 1]
            expressList[i + 1] = this.currentExpress
            this.expressList = [...expressList]
            this.toMergeExpress()
          }
          break
        }
      }
    },
    async save() {
      if (!this.example && !this.tabName === 'BillNo') {
        this.$message.warning(this.tabTitle + this.$t('SystemMaintenance.ConfigurationCannotBeEmpty'))
        return
      }
      if (this.example && this.example.length > this.maxLength) {
        this.$message.warning(this.tabTitle + this.$t('SystemMaintenance.LengthExceedsAllowableLength'))
        return
      }
      if ((!this.config.value || this.config.value.length <= 0) && !(this.tabName === 'BillNo')) {
        this.$message.warning(this.$t('SystemMaintenance.ConfigurationExpressionCannotBeEmpty'))
        return
      }
      const { name, partnerId,
        childNoExtension,
        childNoLetter,
        childNoLetterFriendly,
        childNoNumber,
        childNoSplit } = this.details
      if (this.isMbl && !name) {
        this.$message.warning(this.$t('SystemMaintenance.ThereAtLeastOneName'))
        return
      }
      if (!(childNoExtension ||
        childNoLetter ||
        childNoLetterFriendly ||
        childNoNumber)) {
        this.$message.warning(this.$t('SystemMaintenance.JoiningMustChooseAtItem'))
        return
      }
      const flag = await this.$confirm(this.$t('SystemMaintenance.ChangingInTheSystemModification'), this.$t('common.tips.prompt'), {
        confirmButtonText: this.$t('common.btn.ok'),
        cancelButtonText: this.$t('common.btn.cancel'),
        type: 'warning'
      }).then(() => true).catch(() => false)
      if (!flag) {
        return
      }
      this.loading = getLoading()
      try {
        await cache.load(cacheName.OFFICE)
        const { value, overrideable } = this.config
        await saveOfficeConfig({
          officeId: cache.office.officeId,
          configName: this.lob + (this.tabName === 'BillNo' ? this.billType : '') + this.tabName + 'Pattern',
          configValue: value,
          detailValue: value,
          overrideable,
          childNoExtension,
          childNoLetter,
          childNoLetterFriendly,
          childNoNumber,
          childNoSplit,
          detailName: name,
          detailPartnerId: partnerId
        }).then(res => {
          this.onLobChange()
          this.$message.success(this.$t('SystemMaintenance.SaveSuccess'))
        })
        this.isEdit = false
      } finally {
        this.loading.close()
      }
    },
    async handleAddRule() {
      const { name } = this.addRule
      if (!name) {
        this.$message.error(this.$t('SystemMaintenance.PleaseEnterRuleName'))
        return
      }
      try {
        const { data } = await validConfig({
          officeId: this.$store.getters.currentOfficeId,
          configName: this.lob + this.tabName + 'Pattern',
          detailName: name
        })
        if (data) {
          this.$message.error(this.$t('SystemMaintenance.RuleNameAlreadyExists'))
          return
        }
        await saveOfficeConfig({
          officeId: this.$store.getters.currentOfficeId,
          configName: this.lob + this.tabName + 'Pattern',
          configValue: '${lob}',
          detailValue: '${lob}',
          overrideable: false,
          childNoExtension: false,
          childNoLetter: true,
          childNoLetterFriendly: false,
          childNoNumber: false,
          childNoSplit: '',
          detailName: name,
          detailPartnerId: 0
        })
        this.$message.success(this.$t('SystemMaintenance.SaveSuccess'))
        this.addRule.name = ''
        this.ruleName = name
        this.onLobChange()
        this.addRule.visible = false
      } catch (e) {
        this.$message.error(this.$t('SystemMaintenance.SaveFailed'))
      }
    },
    removeRule() {
      const { ruleName } = this
      this.$confirm(this.$t('SystemMaintenance.AreWantToDeleteRule'), this.$t('SystemMaintenance.Prompt'), {
        confirmButtonText: this.$t('SystemMaintenance.OK'),
        cancelButtonText: this.$t('SystemMaintenance.Cancel'),
        type: 'warning'
      }).then(() => {
        deleteConfig({
          officeId: this.$store.getters.currentOfficeId,
          configName: this.lob + this.tabName + 'Pattern',
          detailName: ruleName
        }).then(() => {
          this.ruleName = ''
          this.$message.success(this.$t('SystemMaintenance.DeleteSuccess'))
          this.onLobChange()
        })
      })
    },
    ruleChange() {
      const { ruleName } = this
      this.details = { ...this.config.details.find(item => item.name === ruleName) }
      this.config.value = this.details.value
      this.config.overrideable = this.details.overrideable
      this.toForm()
    },
    lookConfig() {
      this.lookConfigDialog.visible = true
      this.$nextTick(() => {
        this.$refs.numberConfigSearchDialog.toQuery()
      })
    },
    async queryHandle(filterParam) {
      this.loading = getLoading()
      try {
        const res = await queryAllConfig(filterParam)
        const resultData = res.data
        this.toExpressList(resultData)
        this.$refs.numberConfigSearchDialog.onShow(resultData)
      } finally {
        this.loading.close()
      }
    },
    toExpressList(resultData) {
      /* 解析表达式 */
      const patternList = resultData.map(item => item.configValue)
      for (const pattern of patternList) {
        const expressList = []
        let index = -1
        for (let i = 0; i < pattern.length; ++i) {
          if (pattern[i] === '$' && pattern[i + 1] === '{') {
            index = i
            continue
          }
          if (pattern[i] === '}' && index > -1) {
            let name = pattern.substring(index + 2, i)
            let value = null
            if (name.indexOf('containerLoadType') === 0 || name.indexOf('operateType') === 0 || name.indexOf('cargoSource') === 0) {
              const words = name.split(':')
              const subWords = words[1].split('|')
              name = words[0]
              value = { checked: true, val1: subWords[0] || '', val2: subWords[1] || '' }
            } else if ((this.lob === 'RE' || this.lob === 'RI') && name.indexOf('lob') === 0) {
              const words = name.split(':')
              if (words.length === 1) {
                name = 'lob'
                value = this.lob
              } else {
                name = words[0]
                value = words[1]
              }
            } else if (name.indexOf('Y') === 0) {
              value = { checked: true, length: this.toCountChar(name, 'Y') }
              name = 'year'
            } else if (name.indexOf('M') === 0) {
              value = { checked: true, length: this.toCountChar(name, 'M') }
              name = 'month'
            } else if (name.indexOf('D') === 0) {
              value = { checked: true, length: this.toCountChar(name, 'D') }
              name = 'day'
            } else if (name.indexOf('J') === 0) {
              value = { checked: true, length: this.toCountChar(name, 'J') }
              name = 'jobSequence'
            } else if (name.indexOf('S') === 0) {
              const words = name.split(':')
              value = { checked: true, length: this.toCountChar(words[0], 'S'), set: '', O: false, C: false }
              const str = words[1] || ''
              for (let i = 0; i < str.length; ++i) {
                const c = str.charAt(i)
                if (c === 'O') {
                  value.O = true
                } else if (c === 'C') {
                  value.C = true
                } else {
                  value.set = c
                }
              }
              name = 'sequence'
            } else if (name.indexOf('customJobType') === 0) {
              const words = name.split(':')
              value = { checked: true, length: words[1].length }
              name = words[0]
            } else if (name.indexOf('partnerWarehouseCode') === 0) {
              const words = name.split(':')
              const subWords = words[1].split('|')
              name = words[0]
              value = { checked: true, valList: subWords.map(subWord => ({ code: subWord, name: WarehouseCodeUtil.getName(subWord) })) }
            } else if (name.indexOf('R') === 0) {
              value = { checked: true, length: this.toCountChar(name, 'R') }
              name = 'randomLetter'
            } else {
              name = name
              value = true
            }
            expressList.push({ name, text: pattern.substring(index, i + 1), value })
            index = -1
          }
        }
        /* 识别常量 */
        /* 识别常量 */
        const expList = []
        let preIndex = 0
        let curIndex = 0
        for (const item of expressList) {
          curIndex = pattern.indexOf(item.text)
          if (curIndex > preIndex) {
            const name = pattern.substring(preIndex, curIndex)
            const text = name
            const sequence = this.autoIncrementNum.getNextNum()
            expList.push({ name, text, isConstant: true, sequence })
          }
          expList.push(item)
          preIndex = curIndex + item.text.length
        }
        if (preIndex < pattern.length) {
          const name = pattern.substring(preIndex)
          const text = name
          const sequence = this.autoIncrementNum.getNextNum()
          expList.push({ name, text, isConstant: true, sequence })
        }
        const example = this.getExample(expList)
        resultData.forEach(item => {
          if (item.configValue === pattern) {
            item.example = example
          }
        })
      }
    },
    getExample(expressList) {
      let example = ''
      for (const item of expressList) {
        if (item.isConstant) {
          example += item.text
          continue
        }
        example = this.doGetExample(item, example)
      }
      return example
    },
    changeIo(checkedF) {
      if (checkedF) {
        this.form.io = true
      }
    },
    doGetExample(item, example) {
      switch (item.name) {
        case 'lob':
          if (this.lob === 'RE' || this.lob === 'RI') {
            example += this.form.val1
          } else {
            // CARGO-25543 1.13 单号配置
            // 如果选的是FBA业务，则显示的时候将FBA去掉
            if (this.lob.startsWith('FBA')) {
              const curLob = this.lob.split('FBA')[1]
              example += curLob
            } else {
              example += this.lob
            }
          }
          break
        case 'containerLoadType':
          if (item.value.val1) {
            example += item.value.val1
          } else {
            example += 'F'
          }
          break
        case 'operateType':
          if (item.value.val1) {
            example += item.value.val1
          } else {
            example += 'Z'
          }
          break
        case 'cargoSource':
          if (item.value.val1) {
            example += item.value.val1
          } else {
            example += 'N'
          }
          break
        case 'office':
          example += cache.office.code
          break
        case 'userCode':
          example += 'ABC'
          break
        case 'opCode':
          example += 'OPC'
          break
        case 'netCode':
          example += 'NC'
          break
        case 'salesDepart':
        case 'opDepart':
          if (cache.department.jobNoPrefix) {
            example += cache.department.jobNoPrefix
          }
          break
        case 'warehouseCode':
          example += 'ONT8'
          break
        case 'basicPol':
        case 'port':
        case 'pol':
        case 'pod':
          if (this.lob === 'AE' || this.lob === 'AI') {
            example += 'PVG'
          } else {
            example += 'SHA'
          }
          break
        case 'polExCode':
        case 'podExCode':
          example += 'SH'
          break
        case 'sacaCode':
          example += 'SHW'
          break
        case 'groupCode':
          example += 'A'
          break
        case 'jobNo':
          example += this.$t('SystemMaintenance.PleaseToJobNumberSettings')
          break
        case 'year':
          example += this.toFormatNumber(new Date().getFullYear(), item.value.length)
          break
        case 'month':
          example += this.toFormatNumber(new Date().getMonth() + 1, item.value.length)
          break
        case 'day':
          example += this.toFormatNumber(new Date().getDate(), item.value.length)
          break
        case 'jobSequence':
          example += '12345'.substr(0, item.value.length)
          break
        case 'sequence':
          example += '123456789'.substr(0, item.value.length)
          break
        case 'etd':
          example += ''
          break
        case 'businessDate':
          example += ''
          break
        case 'eta':
          example += ''
          break
        case 'io':
          example += 'D'
          break
        case 'customJobType':
          example += 'CCCC'.substr(0, item.value.length) // 默认写一个，LYZX代表陆运动物园
          break
        case 'partnerWarehouseCode':
          example += 'PWH'
          break
        case 'randomLetter':
          example += 'ABCD'.substring(0, item.value.length)
          break
        case 'rp':
          example += 'R'
          break
        case 'billDate':
          example += ''
          break
        case 'payDate':
          example += ''
          break
        default:
          break
      }
      return example
    }
  }
}
</script>

<style scoped>
.flex-column {
  display: flex;
  flex-direction: column;
}
.inner-row {
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-justify-content: space-between;
  -ms-flex-pack: justify;
  justify-content: space-between;
  padding: 0 16px 0 16px;
}
.not-click {
  pointer-events: none;
}
.row-constant span {
  color: #67c23a;
}
i.edit-btn {
  font-size: 14px;
  line-height: 23px;
  color: #1890ff;
  padding: 0 2px;
  cursor: pointer;
}
i.delete-btn {
  font-size: 14px;
  line-height: 23px;
  color: red;
  padding: 0 2px;
  cursor: pointer;
}
</style>
